import { View, Text } from "@src/components";
import { PressableScale } from "pressto";
import { StyleSheet, useUnistyles } from "react-native-unistyles";
import { memo, type FC, type ReactElement } from "react";
import { Icon } from "@src/components/Icon";

type SettingsCameraItemProps = {
  icon: ReactElement;
  title: string;
  subtitle?: string;
  onPress: () => void;
  additionalSection?: ReactElement;
};

export const SettingsCameraItem: FC<SettingsCameraItemProps> = memo(
  ({ icon, title, subtitle, onPress, additionalSection }) => {
    const { theme } = useUnistyles();

    return (
      <PressableScale onPress={onPress}>
        <View bg="surface" mt="md" style={styles.container}>
          <View flexDirection="row" justifyContent="space-between" alignItems="center">
            <View flexDirection="row" gap="md" alignItems="center" flex={1}>
              {icon}
              <Text textStyle="sm/regular" color="text">
                {title}
              </Text>
            </View>
            {subtitle && (
              <Text textStyle="xs/regular" color="textMuted">
                {subtitle}
              </Text>
            )}
            <Icon name="chevronRight" color={theme.colors.textMuted} style={{ marginLeft: theme.spacing.lg }} />
          </View>
          {additionalSection && additionalSection}
        </View>
      </PressableScale>
    );
  },
);

const styles = StyleSheet.create((theme) => ({
  container: {
    borderColor: theme.colors.border,
    borderWidth: 1,
    borderRadius: theme.spacing.lg,
    paddingVertical: theme.spacing.xl,
    paddingHorizontal: theme.spacing["3xl"],
  },
}));
